/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Divider from '@material-ui/core/Divider';
import React from 'react';
import { CURRENCY_SYMPLE_TYPE } from 'shared/enums/FeeCellType';
import i18next from 'i18next';
import { lookupItemNameI18nProperties } from '../../../../shared/utils/objectUtils';
import { generateAttachmentItems } from '../attachments/attachments.helper';
import { attachmentTypes } from '../../../draft/attachments/services/constants';
import { SubmissionSectionType } from '../../../common/SummaryCard/CardBody/SubmissionSectionType';

// selected method of payment summary entry
export const createMethodOfPaymentEntry = (fees, submissionSchemaReady, schema) => {
  // this points towards the procedure local Jsonschema method of payment definition
  let methodOfPaymentEntry = {
    title: i18next.t('methodOfPayment'),
    value: 'itemNameI18n(methodOfPayment, methodOfPayment)',
  };
  if (submissionSchemaReady) {
    methodOfPaymentEntry = lookupItemNameI18nProperties(methodOfPaymentEntry, fees, schema);
  }
  return methodOfPaymentEntry;
};

// payment attachments summary entries
export const createPaymentAttachmentEntries = (paymentDocuments, t) => {
  if (Array.isArray(paymentDocuments) && paymentDocuments.length > 0) {
    return generateAttachmentItems(
      t,
      paymentDocuments,
      attachmentTypes.PAYMENT,
      t('summary.see.all.documents.payment'),
      [],
      false,
    );
  }
  return [];
};

// selected fees summary section
export const createSelectedFeesSection = (feesSelection, amountFormatter, t, currencyPosition, uiSchema) => {
  const currency =
    feesSelection?.currencySymbol ??
    uiSchema?.fees?.feesSelection?.['ui:data']?.currency ??
    CURRENCY_SYMPLE_TYPE?.DEFAULTCURRENCY;

  const feeTableSection = {
    sectionHeader: t('summary.see.all.selected.fees'),
    sectionIcon: 'edit',
    sectionLinkTo: 'submission_fees_feesSelection',
  };
  feeTableSection.items =
    feesSelection?.selectedFees &&
    Object.keys(feesSelection?.selectedFees).length > 0 &&
    feesSelection?.selectedFees?.map((fee) => {
      const feeTxt = amountFormatter.format(fee.subtotal);
      const feeTextWithCurrency = currencyPosition ? `${feeTxt} ${currency}` : `${currency} ${feeTxt}`;
      return {
        title: fee.code?.concat(' - ', t(`fees.shortDescription.${fee.code}`)),
        type: SubmissionSectionType.FEES,
        value: feeTextWithCurrency,
      };
    });

  return feeTableSection;
};

// summary bottom divider + total entries
export const createTotalFeesFooterEntries = (feesSelection, amountFormatter, t, currencyPosition, uiSchema) => {
  const currency =
    feesSelection?.currencySymbol ??
    uiSchema?.fees?.feesSelection?.['ui:data']?.currency ??
    CURRENCY_SYMPLE_TYPE?.DEFAULTCURRENCY;

  const total = feesSelection?.total && !Number.isNaN(Number(feesSelection?.total)) ? feesSelection?.total : 0;
  const feeTextWithCurrency = currencyPosition
    ? amountFormatter.format(total)?.concat(' ', currency)
    : currency?.concat(' ', amountFormatter.format(total));

  const totalFeesFooter = [];
  totalFeesFooter.push({
    title: <Divider />,
    noScroll: true,
  });
  totalFeesFooter.push({
    title: t('fees.total.fee'),
    value: feeTextWithCurrency,
    noScroll: true,
  });

  return totalFeesFooter;
};
